// extracted by mini-css-extract-plugin
export default {"blockLoading":"BlockLoading_blockLoading__NhIsz","loader":"BlockLoading_loader__39qUt","rot1":"BlockLoading_rot1__XN-Y5"};